import React from 'react';

export default function NavFooter() {
  return (
    <div id="NavFooter" className="Footer">
      <h6>Powered by &lt;strong&gt; Coffee. &lt;/strong&gt;</h6>
      <p id="subFooter">Image by Paris Gore (@parisgore)</p>
    </div>
  );
}
